<template>
  <div>
    <div class="container" align="left">
      <div class="d-inline-block my-5">
        <h4 class="mb-4">
          <strong>{{ $t('CEPG_main_title') }}</strong>
        </h4>
        <h4 class="mt-5 mb-4">
          <strong>{{ $t('CEPG_title1') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle1_1') }}</strong>
        </h5>
        <p>
          {{ $t('CEPG_sub1_1_desc1') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle1_2') }}</strong>
        </h5>
        <p v-html="$t('CEPG_sub1_2_desc1')"></p>
        <p class="numText1"></p>
        <p class="numText1">{{ $t('CEPG_sub1_2_desc2') }}<br /></p>
        <p class="numText1">{{ $t('CEPG_sub1_2_desc3') }}<br /></p>
        <p class="numText1">{{ $t('CEPG_sub1_2_desc4') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle1_3') }}</strong>
        </h5>
        <p v-html="$t('CEPG_sub1_3_desc1')"></p>
        <h4 class="mt-5 mb-4">
          <strong>{{ $t('CEPG_title2') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle2_1') }}</strong>
        </h5>
        <p>{{ $t('CEPG_sub2_1_desc1') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle2_2') }}</strong>
        </h5>
        <p class="numText2">
          {{ $t('CEPG_sub2_2_desc1') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub2_2_desc2') }}
        </p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc3') }}<br /></p>

        <p class="numText3">{{ $t('CEPG_sub2_2_desc4') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc5') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc6') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc7') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc8') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc9') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc10') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc11') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_2_desc12') }}</p>
        <p class="numText2">
          {{ $t('CEPG_sub2_2_desc13') }}
        </p>

        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle2_3') }}</strong>
        </h5>
        <p>{{ $t('CEPG_sub2_3_desc1') }}</p>
        <p class="numText2">{{ $t('CEPG_sub2_3_desc2') }}<br /></p>

        <p class="numText2">{{ $t('CEPG_sub2_3_desc3') }}<br /></p>

        <p class="numText2">{{ $t('CEPG_sub2_3_desc4') }}<br /></p>
        <p class="numText2">{{ $t('CEPG_sub2_3_desc5') }}<br /></p>

        <p class="numText2">
          {{ $t('CEPG_sub2_3_desc6') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle2_4') }}</strong>
        </h5>
        <p class="numText2">{{ $t('CEPG_sub2_4_desc1') }}<br /></p>

        <p class="numText2">{{ $t('CEPG_sub2_4_desc2') }}<br /></p>
        <p class="numText2">{{ $t('CEPG_sub2_4_desc3') }}</p>
        <p class="numText2">{{ $t('CEPG_sub2_4_desc4') }}</p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle2_5') }}</strong>
        </h5>
        <p class="numText2">{{ $t('CEPG_sub2_5_desc1') }}<br /></p>

        <p class="numText2">{{ $t('CEPG_sub2_5_desc2') }}<br /></p>
        <p class="numText2">
          {{ $t('CEPG_sub2_5_desc3') }}
        </p>
        <p class="numText3">{{ $t('CEPG_sub2_5_desc4') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_5_desc5') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_5_desc6') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_5_desc7') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub2_5_desc8') }}<br /></p>
        <h4 class="mt-5 mb-4">
          <strong>{{ $t('CEPG_title3') }}</strong>
        </h4>
        <p>
          {{ $t('CEPG_desc2') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle3_1') }}</strong>
        </h5>
        <p class="numText2">{{ $t('CEPG_sub3_1_desc1') }}<br /></p>

        <p class="numText2">{{ $t('CEPG_sub3_1_desc2') }}<br /></p>

        <p class="numText2">
          {{ $t('CEPG_sub3_1_desc3') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle3_2') }}</strong>
        </h5>
        <p class="numText2">{{ $t('CEPG_sub3_2_desc1') }}<br /></p>

        <p class="numText2">
          {{ $t('CEPG_sub3_2_desc2') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle3_3') }}</strong>
        </h5>
        <p class="numText2">
          {{ $t('CEPG_sub3_3_desc1') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub3_3_desc2') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub3_3_desc3') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle3_4') }}</strong>
        </h5>
        <p class="numText2">
          {{ $t('CEPG_sub3_4_desc1') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub3_4_desc2') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub3_4_desc3') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub3_4_desc4') }}
        </p>
        <p class="numText2">
          {{ $t('CEPG_sub3_4_desc5') }}
        </p>
        <h4 class="mt-5 mb-4">
          <strong>{{ $t('CEPG_title4') }}</strong>
        </h4>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle4_1') }}</strong>
        </h5>
        <p class="numText2">{{ $t('CEPG_sub4_1_desc1') }}<br /></p>

        <p class="numText2">{{ $t('CEPG_sub4_1_desc2') }}<br /></p>

        <p class="numText2">
          {{ $t('CEPG_sub4_1_desc3') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle4_2') }}</strong>
        </h5>
        <p class="numText2">{{ $t('CEPG_sub4_2_desc1') }}</p>
        <p class="numText3">{{ $t('CEPG_sub4_2_desc2') }}<br /></p>

        <p class="numText4">{{ $t('CEPG_sub4_2_desc3') }}<br /></p>

        <p class="numText4">{{ $t('CEPG_sub4_2_desc4') }}<br /></p>

        <p class="numText3">{{ $t('CEPG_sub4_2_desc5') }}<br /></p>
        <p class="numText3">
          {{ $t('CEPG_sub4_2_desc6') }}
        </p>
        <p class="numText2">{{ $t('CEPG_sub4_2_desc7') }}</p>
        <p class="numText3">{{ $t('CEPG_sub4_2_desc8') }}<br /></p>

        <p class="numText4">{{ $t('CEPG_sub4_2_desc9') }}<br /></p>

        <p class="numText3">
          {{ $t('CEPG_sub4_2_desc10') }}
        </p>
        <p class="numText2">{{ $t('CEPG_sub4_2_desc11') }}</p>
        <p class="numText3">
          {{ $t('CEPG_sub4_2_desc12') }}
        </p>
        <p class="numText3"></p>
        <p class="numText3">{{ $t('CEPG_sub4_2_desc13') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub4_2_desc14') }}<br /></p>

        <p class="numText3">{{ $t('CEPG_sub4_2_desc15') }}<br /></p>

        <p class="numText4">
          {{ $t('CEPG_sub4_2_desc16') }}
        </p>
        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle4_3') }}</strong>
        </h5>
        <p v-html="$t('CEPG_sub4_3_desc1')"><br /></p>

        <p class="numText3">{{ $t('CEPG_sub4_3_desc2') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub4_3_desc3') }}<br /></p>

        <h5 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_subtitle4_4') }}</strong>
        </h5>
        <p class="numText3">{{ $t('CEPG_sub4_4_desc1') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_sub4_4_desc2') }}<br /></p>

        <h4 class="mt-5 mb-3">
          <strong>{{ $t('CEPG_add_title') }}</strong>
        </h4>
        <p class="numText3">{{ $t('CEPG_add_sub1_desc1') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_add_sub1_desc2') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_add_sub1_desc3') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_add_sub1_desc4') }}<br /></p>
        <p class="numText3">{{ $t('CEPG_add_sub1_desc5') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Practiceguideline',
  data() {
    return {
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
};
</script>

<style scoped lang="scss">
p {
  word-break: keep-all;
}
.numText0 {
  margin-left: 1.5rem;
  text-indent: -1.5rem;
}
.numText1 {
  margin-left: 1rem;
  text-indent: -0.7rem;
}
.numText2 {
  margin-left: 1rem;

  text-indent: -1rem;
}
.numText3 {
  margin-left: 2rem;
  text-indent: -0.6rem;
}
.numText4 {
  margin-left: 3rem;
  text-indent: -1rem;
}
</style>

<i18n>
{
  "ko": {
    "CEPG_main_title": "윤리규범 실천지침",
    "CEPG_title1": "제1장 총 칙",
    "CEPG_subtitle1_1": "제1조 목 적",
    "CEPG_sub1_1_desc1": "본 ‘윤리규범 실천지침(이하 ‘실천지침’)은 SK핀크스 주식회사의 구성원이 윤리규범을 올바르게 이해하고 실천할 수 있도록 업무수행 과정에서 발생할 수 있는 윤리적 갈등상황에 대해 의사결정과 행동의 판단기준을 제공함에 그 목적이 있다.",
    "CEPG_subtitle1_2": "제2조 윤리적 의사결정 및 행동원칙",
    "CEPG_sub1_2_desc1": "구성원은 직무수행과 관련하여 윤리적 갈등상황에 놓이게 될 경우 윤리규범과 본 실천지침을 기준으로 판단하고 행동하여야 한다.<br> 단, 실천지침에 판단기준이 명확하게 규정되어 있지 않은 경우 다음의 의사결정원칙에 따라 판단하고 행동하여야 하며, 자신의 판단에 확신이 없는 경우에는 조직의 리더 또는 윤리경영 담당부서의 자문에 따라 행동하여야 한다.",
    "CEPG_sub1_2_desc2": "가. 합법성 : 자신의 행동이 법규 또는 사규 위반으로 해석될 가능성이 있는가?",
    "CEPG_sub1_2_desc3": "나. 투명성 : 자신의 의사결정 과정과 내용을 공개할 수 있는가?",
    "CEPG_sub1_2_desc4": "다. 합리성 : 다른 구성원들도 동일한 상황에서 같은 결정을 할 것인가?",
    "CEPG_subtitle1_3": "제3조 적용대상",
    "CEPG_sub1_3_desc1": "본 실천지침은 SK핀크스 주식회사에 재직중인 경영진을 포함한 모든 구성원(계약직, 파견직, 시간제 포함)을 대상으로 한다.<br> 회사의 이해관계자에게도 본 실천지침을 이해시키고 실천을 권장한다.",
    "CEPG_title2": "제2장 구성원의 자세",
    "CEPG_subtitle2_1": "제4조 성실한 업무수행",
    "CEPG_sub2_1_desc1": "구성원은 자신의 권한과 책임을 명확히 인식하고 신의성실의 원칙에 따라 직무를 수행하여야 한다.",
    "CEPG_subtitle2_2": "제5조 이해상충의 해결",
    "CEPG_sub2_2_desc1": "① 구성원은 직무수행과 관련하여 회사와 이해가 상충되는 어떠한 행위나 관계가 발생하지 않도록 노력하며 이해가 상충될 경우는 회사의 이익을 우선적으로 생각하고 이를 위반하는 것을 발견할 경우 윤리경영 담당부서에 신고하여야 한다.",
    "CEPG_sub2_2_desc2": "② 구성원이 업무영향력을 행사할 수 있거나 업무수행에 있어 구성원의 판단이나 행동에 영향을 줄 수 있다고 생각되는 이해상충행위는 다음과 같다.",
    "CEPG_sub2_2_desc3": "1. 본인이 직접 또는 제3자를 통하여 회사와 계약 또는 거래하는 행위",
    "CEPG_sub2_2_desc4": "2. 본인이 직접 또는 제3자를 통하여 경쟁업체 또는 협력회사와 거래하는 행위",
    "CEPG_sub2_2_desc5": "3. 회사의 승인 없이 이해관계가 있는 타 회사의 직위를 겸임하는 행위",
    "CEPG_sub2_2_desc6": "4. 협력회사와 금전대차, 공동투자, 대출보증, 부동산 또는 동산의 임대차 등의 거래 관계를 맺는 행위",
    "CEPG_sub2_2_desc7": "5. 본인이 직접 또는 제3자를 통하여 협력회사로부터 보상을 받는 행위",
    "CEPG_sub2_2_desc8": "6. 본인이 직접 또는 제3자를 통하여 협력회사의 주식, 채권 등을 취득하는 행위(단, 회사의 승인이 있는 경우는 예외로 한다)",
    "CEPG_sub2_2_desc9": "7. 가족 또는 친인척이 회사 및 협력회사와 거래하는 행위",
    "CEPG_sub2_2_desc10": "8. 본인 및 배우자, 친인척이 경영권 행사가 가능한 협력회사의 지분을 보유하거나 대표이사 감사-임원 등 경영진의 직무를 수행하는 행위",
    "CEPG_sub2_2_desc11": "9. 회사의 자산이나 경영정보를 이용하여 부당하게 사적 이익을 취하는 행위",
    "CEPG_sub2_2_desc12": "10. 업무상 지위를 남용하여 협력회사에 대한 인사청탁, 각종 편의제공 요구 등 부당한 영향력을 행사하는 행위",
    "CEPG_sub2_2_desc13": "③ 위 제2항은 이행상충 행위의 예시로서 위에 예시한 행위 이외의 경우에도 구성원은 본인의 행위가 이해상충 행위에 해당하는지 여부를 엄격하게 판단하여 본 실천지침을 적용하고 준수하여야 한다.",
    "CEPG_subtitle2_3": "제6조 회사자산 및 정보의 보호와 적절한 사용",
    "CEPG_sub2_3_desc1": "구성원은 회사의 유·무형자산을 보호하고 정당하게 사용하여야 한다.",
    "CEPG_sub2_3_desc2": "① 회사의 자산을 승인 없이 개인적인 이익을 위하여 이용하거나 제3자에게 양도 또는 대여하여서는 아니 된다.",
    "CEPG_sub2_3_desc3": "② 회사의 예산을 개인적인 용도로 사용하지 않으며, 회사가 정한 목적에 맞게 지출하고 회계장부에 정확하게 기록하여야 한다.",
    "CEPG_sub2_3_desc4": "③ PC, 인터넷, 전자메일, 전화/팩스 등을 개인적인 용도로 과도하게 사용하여서는 아니 된다.",
    "CEPG_sub2_3_desc5": "④ 회사의 특허권, 영업권, 상표권, 저작권, 기타 자산가치가 존재하는 정보 등의 지적재산권을 적극적으로 보호하여야 한다. 또한 타인 또는 타사의 지적재산권도 동일하게 보호하여야 하며, 특히 불법 소프트웨어를 사용해서는 아니 된다.",
    "CEPG_sub2_3_desc6": "⑤ 사업정보 및 기술정보를 포함한 회사의 정보자산을 보안관리규정에 따라 엄격히 관리하여야 한다. 정보자산의 공개여부 및 범위는 관련 법규 및 사규, 회사방침에 따라 결정되며 이는 외부 언론과의 인터뷰에도 동일하게 적용된다.",
    "CEPG_subtitle2_4": "제7조 선물, 접대 등의 授受 및 부정청탁 금지",
    "CEPG_sub2_4_desc1": "① 구성원은 공과 사를 업격히 구분하고 모든 경영활동을 공정하고 투명하게 수행하여야 한다.",
    "CEPG_sub2_4_desc2": "② 구성원은 협력회사 등 이해관계자들로부터 부당하고 불공정한 이익의 향유, 개인적 목적으로 금품이나 향응 또는 기타 편의 등을 제공받거나 제공하여서는 아니 된다.",
    "CEPG_sub2_4_desc3": "③ 단, 업무상의 목적으로 상호간의 건전한 관계를 유지하기 위해 부정청탁 및 금품 등 수수의 금지에 관한 법률과 사회 통념상 인정되는 범위 내에서 합리적인 수준의 선물이나 접대 등은 주고 받을 수 있으며, 이에 대한 세부지침은 조직 단위로 제정하여 운용할 수 있다.",
    "CEPG_sub2_4_desc4": "④ 구성원은 부정청탁을 하거나 받아서는 아니 된다.",
    "CEPG_subtitle2_5": "제8조 구성원간의 상호존중",
    "CEPG_sub2_5_desc1": "① 구성원은 동료 및 상하간에 서로 존중하고 직장생활에 필요한 기본예의와 SK 구성원으로서의 품위를 지켜야 한다.",
    "CEPG_sub2_5_desc2": "② 성, 학력, 출신지역, 결혼, 인종, 국적, 종교 등을 이유로 차별대우를 하지 않아야 한다.",
    "CEPG_sub2_5_desc3": "③ 개인의 인권을 침해하고 근무 분위기를 저해할 수 있는 일체의 성희롱 행위를 하여서는 아니 된다. 그 예시는 아래와 같다.",
    "CEPG_sub2_5_desc4": "1. 특정 신체부위를 만지거나 접촉하는 행위",
    "CEPG_sub2_5_desc5": "2. 음란한 농담을 하거나 음탕하고 상스러운 이야기를 하는 행위",
    "CEPG_sub2_5_desc6": "3. 음란한 사진이나 그림 등을 게시하거나 보여주는 행위",
    "CEPG_sub2_5_desc7": "4. 회식, 워크숍, 단체행사 등에서 술시중이나 춤 등을 강요하는 행위",
    "CEPG_sub2_5_desc8": "5. 기타 성적 수취심을 유발시키는 행위",
    "CEPG_title3": "제3장 법규 및 회사 경영방침의 준수",
    "CEPG_desc2": "구성원은 회사 경영활동과 관련된 국내·외 법률 및 회사 방침과 사규를 명확하게 숙지하고 이에 따라 업무를 수행하여야 한다.",
    "CEPG_subtitle3_1": "제9조 경영 정보의 작성과 공개",
    "CEPG_sub3_1_desc1": "① 회계 정보는 일반적으로 인정되는 회계원칙 및 관련 법규, 사규에 따라 정확하게 기록하고 유지하여야 하며 회계정보를 왜곡하거나 숨겨서는 아니 된다.",
    "CEPG_sub3_1_desc2": "② 재무 정보를 포함한 회사의 모든 경영정보는 관련 사실 또는 거래내역을 정확히 반영하여 경영진의 의사결정을 뒷받침할 수 있어야 한다.",
    "CEPG_sub3_1_desc3": "③ 외부 이해관계자에 대한 경영 정보의 공개는 관련 법규 및 사규에 따라 투명하고 공정하게 이루어져야 한다.",
    "CEPG_subtitle3_2": "제10조 공정한 거래와 경쟁",
    "CEPG_sub3_2_desc1": "① 공정거래 관련법규 및 회사의 공정거래자율준수 관리규정을 명확히 이해하고 준수하여야 한다.",
    "CEPG_sub3_2_desc2": "② 공정거래 관련 법규 위반으로 해석될 가능성이 있는 사항에 대해서는 공정거래 또는 법무 담당부서와 사전에 충분한 협의를 거쳐 처리하여야 하며 자의적인 해석에 따라 의사결정을 하여서는 아니 된다.",
    "CEPG_subtitle3_3": "제11조 고객만족과 고객 개인정보의 보호",
    "CEPG_sub3_3_desc1": "① 구성원은 고객을 존중과 배려의 태도로 응대하며, 서비스 과정에서 발생한 고객 문의 및 불만 사항은 신속하고 공정하게 처리한다.",
    "CEPG_sub3_3_desc2": "② 구성원은 회사가 제공하는 서비스와 용역을 고객이 합리적으로 선택할 수 있도록 정확한 정보를 적시에 제공하여야 한다.",
    "CEPG_sub3_3_desc3": "③ 회사는 고객정보보호와 관련된 법령을 준수하고, 고객의 개인정보를 취급하는 구성원은 관련 법규 및 회사의 방침과 사규에 따라 안전하게 개인정보를 보호하여야 하며, 고객의 동의가 있거나 법률상 허용되는 경우를 제외하고는 고객정보를 제공받은 목적 외의 용도로 이용하거나 제3자에게 제공하지 않는다.",
    "CEPG_subtitle3_4": "제12조 안전∙보건∙환경에 대한 방침",
    "CEPG_sub3_4_desc1": "① 안전, 보건, 환경과 관련된 국내·외 법규 및 국제협약을 준수하고, 안전, 보건, 환경 성과의 지속적 개선을 추구하여야 한다.",
    "CEPG_sub3_4_desc2": "② 안전수칙을 준수하여 안전한 작업 환경을 조성하여야 한다.",
    "CEPG_sub3_4_desc3": "③ 각종 재난, 보안 사고 및 비상 상황 발생시, 임직원은 사전에 마련된 비상 대응 매뉴얼에 따라 신속하고 체계적으로 대처하며, 고객과 직원의 안전 확보를 최우선으로 합니다.",
    "CEPG_sub3_4_desc4": "④ 환경문제의 중요성을 인식하고, 환경보호 활동에 적극 참여하여야 한다.",
    "CEPG_sub3_4_desc5": "⑤ 회사는 골프장 코스 유지 시 농약 및 비료 사용을 최소화하고, 물과 에너지를 효율적으로 사용하여 지역 생태계와 환경에 대한 영향을 줄이기 위해 노력한다.",

    "CEPG_title4": "제4장 실천지침의 운영",
    "CEPG_subtitle4_1": "제13조 책임",
    "CEPG_sub4_1_desc1": "① 모든 구성원들은 윤리규범과 실천지침을 준수할 책임이 있으며, 의문이 있는 사항에 대해서는 조직의 리더 또는 윤리경영 담당부서에 질의·상담하여 그 해석에 따라 행동하여야 한다.",
    "CEPG_sub4_1_desc2": "② 조직의 리더는 소속 구성원과 업무상 관련된 이해관계자들이 회사의 윤리규범과 실천지침을 올바르게 이해하고 준수할 수 있도록 적극적으로 지원하고 관리할 책임이 있다. 또한, 성실하고 책임있는 의사결정과 행동을 통하여 윤리규범과 실천지침을 준수함으로써 타의 모범을 보여야 한다.",
    "CEPG_sub4_1_desc3": "③ 윤리규범과 실천지침의 위반사항을 알게 된 구성원은 이를 조직의 리더나 윤리경영 담당부서에 보고 또는 제보하여 조속히 해결할 수 있도록 함으로써, 해당 행위로부터 회사와 구성원을 적극적으로 보호하여야 한다.",
    "CEPG_subtitle4_2": "제14조 제보자 보호",
    "CEPG_sub4_2_desc1": "① 제보자 보호 방침",
    "CEPG_sub4_2_desc2": "1. 제보자는 정당한 제보나 이와 관련한 진술, 자료제출 등을 한 이유로 임직원이나 소속 부서 등으로부터 신분상의 불이익이나 근무 조건상의 차별을 받지 아니 한다.",
    "CEPG_sub4_2_desc3": "- 제보자는 제보로 인하여 불이익 처분을 받았을 경우, 그 시정과 부서이동 등 보호 조치를 윤리경영 담당부서에 요청할 수 있다.",
    "CEPG_sub4_2_desc4": "- 윤리경영 담당부서는 제보자로부터 시정/보호 요청이 있을 경우 제보자의 불이익이 최소화되도록 조치하고, 관련자에 대한 제재조치를 포함한 재발방지 대책을 수립/실시한다.",
    "CEPG_sub4_2_desc5": "2. 회사는 제보자의 신원 및 제보 내용이 본인의 의사에 반하여 공개되지 않도록 비밀을 유지한다.",
    "CEPG_sub4_2_desc6": "3. 회사는 제보자 外 제보에 대한 사실확인 과정에서 진술, 자료제공 등의 방법으로 조사에 협조한 자에 대해서도 제보자와 동등하게 보호한다.",
    "CEPG_sub4_2_desc7": "② 제재 및 감면",
    "CEPG_sub4_2_desc8": "1. 회사는 상기 1)에서 규정한‘제보자 보호 방침’을 위반한 자를 징계 관련 규정에 따라 조치한다. 본 조치대상이 되는 주요 행위는 다음과 같다.",
    "CEPG_sub4_2_desc9": "- 제보자에게 제보로 인하여 불이익을 주는 보복조치, 직무상 또는 우연히 인지한 제보자 신원이나 제보 내용의 누설, 제보자를 색출하거나 색출을 지시하는 행위 등",
    "CEPG_sub4_2_desc10": "2. 윤리규범 또는 실천지침에 저촉되는 활동 또는 위법 행위에 가담하였으나, 이에 대한 사실을 자진 신고한 경우에는 그 행위에 대한 처벌이나 징계 시 정상을 참작할 수 있다.",
    "CEPG_sub4_2_desc11": "③ 제보조사 수행지침",
    "CEPG_sub4_2_desc12": "제보조사 담당자 및 부서장은 업무를 수행함에 있어 제보자 보호를 최우선 원칙으로 하여 조사를 진행하여야 하며, 아래 사항을 반드시 준수해야 한다.",
    "CEPG_sub4_2_desc13": "1. 제보자의 동의 없이 제보와 관련된 어떠한 정보나 내용도 유출하거나 암시할 수 없다.",
    "CEPG_sub4_2_desc14": "2. 제보 관련 모든 자료는 허가된 자에게만 열람하며 철저한 보안이 유지되도록 보관하되, 우편 등으로 접수된 종이문서는 시건 장치가 유지된 별도의 보관장소에 보관하여야 한다.",
    "CEPG_sub4_2_desc15": "3. 조사수행 과정에서 인지한 제보자의 신원이나 제보내용을 공개 또는 누설하는 자를 징계 관련 규정에 따라 조치하되, 하기 예외 사항 등 관련 사안의 공개가 제보자의 신원이나 제보내용의 보호보다 중요한 경우 면책할 수 있다. 다만, 이 경우에도 공개의 범위는 필요 최소한이어야 하며, 그 범위를 넘어서는 공개는 면책되지 아니한다.",
    "CEPG_sub4_2_desc16": "- 심각한 인명 안전사고 및 사업 중단을 초래할 수 있는 사항, 중요한 부정사건 관련 사항, 회사 기밀 유출 및 자료 위/변조 관련 사항, 언론 보도 사항 등",
    "CEPG_subtitle4_3": "제15조 윤리상담 및 제보 채널",
    "CEPG_sub4_3_desc1": "상담 및 제보채널은 다음과 같다.",
    "CEPG_sub4_3_desc2": "1. Web : https://ethics.sk.co.kr",
    "CEPG_sub4_3_desc3": "2. 우편: 제주특별자치도 서귀포시 안덕면 산록남로 863 SK핀크스㈜ ESG 팀 윤리경영",
    "CEPG_subtitle4_4": "제16조 준수 및 서약의무",
    "CEPG_sub4_4_desc1": "① 회사의 구성원은 본 윤리규범 실천지침을 준수하고, 매년 정기적으로 서약할 의무가 있다.",
    "CEPG_sub4_4_desc2": "② 본 실천지침을 위반한 경우에는 회사의 사규에 따라 조치한다.",

    "CEPG_add_title": "부칙",
    "CEPG_add_sub1_desc1": "본 실천지침은 2011년 3월 11일부로 제정한다.",
    "CEPG_add_sub1_desc2": "본 실천지침은 2018년 2월 21일부로 개정 시행한다.",
    "CEPG_add_sub1_desc3": "본 실천지침은 2018년 7월 17일부로 개정 시행한다.",
    "CEPG_add_sub1_desc4": "본 실천지침은 2021년 3월 29일부로 개정 시행한다.",
    "CEPG_add_sub1_desc5": "본 실천지침은 2025년 2월 14일부로 개정 시행한다."
  },
  "en": {
    "CEPG_main_title": "Code of Ethics Practice Guideline",
    "CEPG_title1": "Chapter 1 General Principles",
    "CEPG_subtitle1_1": "Article 1 (Purpose)",
    "CEPG_sub1_1_desc1": "The Code of Ethics Guidelines (here in after these “Guidelines”) aim to provide the criteria for decision making and action regarding ethical dilemmas, which may arise in the course of work, to assist the Members of SKPINX CO.,LTD to understand and properly act upon the Company’s Code of Ethics.",
    "CEPG_subtitle1_2": "Article 2 (Principles of ethical decision-making and conduct)",
    "CEPG_sub1_2_desc1": "Covered Persons shall act in accordance with the Code of Ethics and these Guidelines in case of an ethical dilemma faced in the course of work. In case these Guidelines lack clear guidance for a particular case, Covered Persons shall act in accordance with the following principles of decision-making, and if one is uncertain of his or her judgment, such Covered Persons shall seek the advice of his or her leader or that of the ethics department for correct interpretation and shall act in accordance with such interpretation.",
    "CEPG_sub1_2_desc2": "• Legitimacy : Can the action be interpreted as a violation of laws/regulations or the Company regulations?",
    "CEPG_sub1_2_desc3": "• Transparency : Can the process of decision-making and outcome be disclosed?",
    "CEPG_sub1_2_desc4": "• Rationality : Would other Members make the same decision under the same circumstances?",
    "CEPG_subtitle1_3": "Article 3 (Application)",
    "CEPG_sub1_3_desc1": "The following Practice Guidelines applies to all employees of SK Pinx Co., Ltd., including executives, contract employees, dispatched employees, and part-time workers.  Interested parties of the Company are recommended to understand and practice the terms outlined in this Code of Ethics.",
    "CEPG_title2": "Chapter 2 Workplace Conduct",
    "CEPG_subtitle2_1": "Article 4 (Business Conduct and Integrity)",
    "CEPG_sub2_1_desc1": "Covered Persons must be fully aware of their rights and responsibilities and work in good faith.",
    "CEPG_subtitle2_2": "Article 5 (Settlement of Conflicting Interests)",
    "CEPG_sub2_2_desc1": "① Covered Persons must put in effort to ensure that no action or relationship regarding business practices comes into conflict with the interests of the Company. In the case of conflicting interests, Covered Person must foremost prioritize Company interests and notify the Office of Ethics in the case of emerging violations.",
    "CEPG_sub2_2_desc2": "② The following is a list of practices with conflicting interests that may give a Covered Person business leverage or have leverage on the Covered Person’s business judgement or practice.",
    "CEPG_sub2_2_desc3": "1. Directly or through a third party signing a contract or conducting business with the Company",
    "CEPG_sub2_2_desc4": "2. Directly or through a third party making a transaction with a business competitor or partner",
    "CEPG_sub2_2_desc5": "3. Holding an additional position in an interested company without Company authorization",
    "CEPG_sub2_2_desc6": "4. Establishing a transactional relationship with partner company such as cash loan, joint investment, loan security, real estate, movable car lease, and the like",
    "CEPG_sub2_2_desc7": "5. Directly or through a third party receiving compensation from partner Company",
    "CEPG_sub2_2_desc8": "6. Directly or through a third party acquiring shares or bonds from partner company (exception provided that Covered Person received company authorization)",
    "CEPG_sub2_2_desc9": "7. Family members or relatives of Covered Person conducting business with Company or partner company",
    "CEPG_sub2_2_desc10": "8. Holding shares in a partner company where oneself, one’s spouse, or relatives can exercise management control, or performing executive duties such as CEO, auditor, or executive officer in such a company",
    "CEPG_sub2_2_desc11": "9. Using Company assets or management information to unfairly acquire private benefit",
    "CEPG_sub2_2_desc12": "10. Abusing business position to exert unfair leverage over partner company such as bribing for jobs and requesting special contributions",
    "CEPG_sub2_2_desc13": "③ Article 5-2 above is a partial list of practices with conflicting interests. Covered Persons must make strict judgements in determining whether other practices aside from the examples listed above involve conflicting interests to comply with this Practice Guideline.",
    "CEPG_subtitle2_3": "Article 6 (Appropriate use and protection of the Company’s assets and Information)",
    "CEPG_sub2_3_desc1": "Covered Persons must protect the Company’s tangible and intangible assets and use them for legitimate business purposes.",
    "CEPG_sub2_3_desc2": "① One shall not use the Company’s assets or transfer/lease the Company’s assets to a third party for personal gains without the Company’s authorization or approval.",
    "CEPG_sub2_3_desc3": "② One shall not use the Company’s budget for personal use. The Company’s budget must be used only for the purpose set by the Company, and such use must be accurately recorded in the Company’s accounting books.",
    "CEPG_sub2_3_desc4": "③ One shall not exploit the Company’s computers, Internet, e-mail, phone, fax, etc. for personal use.",
    "CEPG_sub2_3_desc5": "④ One shall strictly protect the Company’s intellectual property rights, including but not limited to patents, trade secrets, trademarks, copyrights, and other proprietary information. The intellectual property rights of third parties shall also receive the same protection, and in particular, illegal software shall not be used.",
    "CEPG_sub2_3_desc6": "⑤ The Company’s proprietary information, including information related to business or technology, shall be strictly managed in accordance with the related Company regulations. The decision of whether or not to disclose information assets and the scope of such disclosure shall be determined according to the relevant laws/regulations and the Company regulations and policy, and the same applies to the interviews with the media.",
    "CEPG_subtitle2_4": "Article 7 (Gifts, Entertainment, and Unfair Solicitation)",
    "CEPG_sub2_4_desc1": "① All Covered Persons must strictly distinguish business conduct from private matters and conduct fair and transparent business practices.",
    "CEPG_sub2_4_desc2": "② All Covered Persons must neither receive nor provide any money, goods, entertainment, and other special contributions from business partners and interested parties for personal use.",
    "CEPG_sub2_4_desc3": "③ However, Covered Persons may receive and provide gifts and entertainment considered reasonable within the provisions of Article 12 (Improper Solicitation and Graft Act) and social customs to maintain a mutually amicable relationship for business purposes, and detailed guidelines may be established and enforced by each organization under deliberation with the supervising department.",
    "CEPG_sub2_4_desc4": "④ All Covered Persons shall neither make nor accept improper solicitations.",
    "CEPG_subtitle2_5": "Article 8 (Mutual Respect in the Workplace)",
    "CEPG_sub2_5_desc1": "① All Covered Persons must respect their colleagues and maintain basic etiquette and integrity required in the workplace to eliminate disincentives and foster a healthy corporate environment.",
    "CEPG_sub2_5_desc2": "② All Covered Persons must not discriminate one another for reasons of gender, education, region of origin, marital status, race, nationality, religion, and the like.",
    "CEPG_sub2_5_desc3": "③ All Covered Persons must not commit any action of sexual harassment or personal leverage that may violate an individual’s rights and impede the work environment. The examples are as follows.",
    "CEPG_sub2_5_desc4": "1. Inappropriate physical contact such as touching a particular part of the body without consent",
    "CEPG_sub2_5_desc5": "2. Making improper jokes or using vulgar language",
    "CEPG_sub2_5_desc6": "3. Sharing or posting obscene images with others",
    "CEPG_sub2_5_desc7": "4. Forcing to serve alcohol or dance at company dinner, workshop, or group events",
    "CEPG_sub2_5_desc8": "5. Other illicit behaviors that could cause sexual humiliation",
    "CEPG_title3": "Chapter 3  Compliance with Laws and Company Policy",
    "CEPG_desc2": "All Covered Persons must have full knowledge of Korean and non-Korean laws and Company policy and announcements applicable to the Company’s business activities, and execute tasks in compliance with such regulations.",
    "CEPG_subtitle3_1": "Article 9 (Disclosureand Reporting of Business Information)",
    "CEPG_sub3_1_desc1": "① Accounting information must be accurately recorded and maintained according to accounting principles, applicable laws, and Company policy, and must not be misrepresented or concealed.",
    "CEPG_sub3_1_desc2": "② All management information including financial information shall accurately reflect all relevant facts and details of business transactions to support the management in making business decisions.",
    "CEPG_sub3_1_desc3": "③ Disclosure of business information to external interested parties must be transparent and fair according to applicable laws and Company policy.",
    "CEPG_subtitle3_2": "Article 10 (Fair Trade and Competition)",
    "CEPG_sub3_2_desc1": "① Covered Persons must accurately understand and comply with laws regarding fair trade and Company’s free trade compliance program.",
    "CEPG_sub3_2_desc2": "② For matters that could potentially be interpreted as legal violations of fair trade, Covered Persons must have sufficient discussions with departments supervising fair trade or legal affairs prior to execution. Decisions must not be made based on arbitrary interpretations.",
    "CEPG_subtitle3_3": "Article 11 (Customer Satisfaction and Protection of Customer Personal Information)",
    "CEPG_sub3_3_desc1": "① Covered Persons shall treat customers with respect and consideration, responding to their inquiries and complaints arising during the service process promptly and fairly.",
    "CEPG_sub3_3_desc2": "② Covered Persons shall provide accurate and timely information to ensure that customers can make reasonable choices regarding the services and offerings provided by the company.",
    "CEPG_sub3_3_desc3": "③ Company must comply with laws regarding the protection of customer information and Covered Persons handling customer personal information must ensure safe protection of such customer information. Unless customer has agreed or permitted by the law, Covered Persons must not use customer information for purposes other than for which it was provided or provide customer information to a third party.",
    "CEPG_subtitle3_4": "Article 12 (Responsibility in Safety, Health, Environment)",
    "CEPG_sub3_4_desc1": "① The company shall comply with domestic and international laws, regulations, and international agreements related to safety, health, and the environment and shall strive for continuous improvement in safety, health, and environmental performance.",
    "CEPG_sub3_4_desc2": "② Covered Persons must strictly follow safety regulations to establish and maintain a safe working environment.",
    "CEPG_sub3_4_desc3": "③ In the event of disasters, security incidents, or emergencies, employees shall respond swiftly and systematically in accordance with the pre-established emergency response manual, prioritizing the safety of customers and employees.",
    "CEPG_sub3_4_desc4": "④ Covered Persons shall recognize the importance of environmental issues and actively participate in environmental protection efforts.",
    "CEPG_sub3_4_desc5": "⑤ The company shall minimize the use of pesticides and fertilizers in golf course maintenance and efficiently manage water and energy consumption to reduce its impact on the local ecosystem and environment.",

    "CEPG_title4": "Chapter 4  Enforcement of Practice Guideline",
    "CEPG_subtitle4_1": "Article 13 (Responsibility)",
    "CEPG_sub4_1_desc1": "① All Covered Persons have a responsibility to comply with the Code of Ethics and Practice Guideline, and for any issues that require further clarification, Covered Persons must inquire and consult with senior management or Office of Ethics to act based on such further interpretations.",
    "CEPG_sub4_1_desc2": "② Senior management has a responsibility to actively support and manage affiliated Covered Persons and business interested parties in accurately understanding and complying with the Company’s Code of Ethics and Practice Guideline. Also, senior management must demonstrate truthful and responsible decision makings and practices in complying with the Code of Ethics and Practice Guideline to set an example for others.",
    "CEPG_sub4_1_desc3": "③ Covered Persons who discover violations of the Code of Ethics and Practice Guideline must notify or report to senior management or the Office of Ethics for prompt resolution, and by doing so, actively protect the Company and Covered Persons from such violation.",
    "CEPG_subtitle4_2": "Article 14 (Whistle-blower Protection)",
    "CEPG_sub4_2_desc1": "① Whistle-blower Protection Policy",
    "CEPG_sub4_2_desc2": "1. Whistle-blowers shall not suffer any identity-based disadvantages or discriminatory treatment in working conditions from employees or departments due to legitimate whistle-blowing, statements, or the submission of related evidence.",
    "CEPG_sub4_2_desc3": "- If a whistle-blower faces adverse consequences due to the whistle-blowing, they may request corrective actions and protective measures such as remediation and departmental transfers from the ethics management department.",
    "CEPG_sub4_2_desc4": "- Upon receiving a request for correction/protection from a whistle-blower, the ethics management department shall take measures to minimize any adverse consequences for the whistle-blower, develop and implement preventive measures, including sanctions against relevant parties, to prevent recurrence.",
    "CEPG_sub4_2_desc5": "2. The company maintains confidentiality to ensure that the identity and the content of the whistle-blowing are not disclosed contrary to their intentions.",
    "CEPG_sub4_2_desc6": "3. The company equally protects individuals who cooperate in the investigation process, providing statements or information during the fact-finding of the whistle-blower, in addition to the whistle-blower.",
    "CEPG_sub4_2_desc7": "② Sanctions and Exemptions",
    "CEPG_sub4_2_desc8": "1. The company takes measures in accordance with disciplinary regulations against individuals who violate the 'Whistle-blower Protection Policy' as stipulated in the above 1). The key actions subject to these measures include: ",
    "CEPG_sub4_2_desc9": "- Retaliatory actions causing detriment to the whistle-blower due to the disclosure, disclosure of the whistle-blower's identity or the content of the disclosure that is learned either through official duties or coincidentally, and actions to identify or instruct the identification of the whistleblower.",
    "CEPG_sub4_2_desc10": "2. In cases where individuals engage in activities that violate code of ethics or its practice guidelines or participate in unlawful actions but voluntarily report such activities, the company may take into consideration of the extenuating circumstances when imposing sanctions or disciplinary actions for those actions.",
    "CEPG_sub4_2_desc11": "③ Whistle-blower Investigation Guidelines",
    "CEPG_sub4_2_desc12": "Those responsible for conducting whistle-blower investigations, including the investigators and department heads, must prioritize whistle-blower protection as the paramount principle when carrying out their duties. They must adhere strictly to the following: ",
    "CEPG_sub4_2_desc13": "1. No information or content related to the whistle-blower's disclosure can be leaked or implied without the whistle-blower's consent.",
    "CEPG_sub4_2_desc14": "2. All documentation related to the disclosure should only be accessible to authorized personnel, ensuring thorough security measures for storage. Paper documents received through mail, etc., should be stored in a separate secure location with maintained access controls.",
    "CEPG_sub4_2_desc15": "3. Any individual who discloses or leaks the identity of the whistle-blower or the content of the disclosure, as identified during the investigation process, shall be subject to disciplinary measures according to relevant regulations. However, exemptions may be granted if the disclosure of related matters, including the following exceptions, is deemed more critical than the protection of the whistle-blower's identity or disclosure content. Nevertheless, even in such cases, the scope of disclosure should be the absolute minimum necessary, and any disclosure beyond that minimum shall not be exempted.",
    "CEPG_sub4_2_desc16": "- Matters that may cause serious life safety accidents and business interruption, matters related to important fraud cases, matters related to leakage of company secrets and forgery/falsification of data, media reports, etc.",
    "CEPG_subtitle4_3": "Article 15 (Ethics Consultation and Reporting Channels)",
    "CEPG_sub4_3_desc1": "Consultation and Ethics Hotline are the following.",
    "CEPG_sub4_3_desc2": "1. Website: https://ethics.sk.co.kr",
    "CEPG_sub4_3_desc3": "2. Mail: SK Pinx Co., Ltd. ESG TEAM Ethics Management, 863 Sanroknam-ro, Andeok-myeon, Seogwipo-si, Jeju Special Self-Governing Province, Republic of Korea (63525)",
    "CEPG_subtitle4_4": "Article 16 (Duty of Compliance and Pledge)",
    "CEPG_sub4_4_desc1": "① Covered Persons of SK PINX have a duty to comply with this Code of Ethics Practice Guideline and regularly pledge every year.",
    "CEPG_sub4_4_desc2": "② The Company will take action against any violations of this Practice Guideline according to Company policy.",

    "CEPG_add_title": "Supplementary Provisions",
    "CEPG_add_sub1_desc1": "This Code of Ethics will take effect from March 11, 2011.",
    "CEPG_add_sub1_desc2": "This amended Code of Ethics will come into force from February 21, 2018.",
    "CEPG_add_sub1_desc3": "This amended Code of Ethics will come into force from July 17, 2018.",
    "CEPG_add_sub1_desc4": "This amended Code of Ethics will come into force from March 29, 2021.",
    "CEPG_add_sub1_desc5": "This amended Code of Ethics will come into force from February 14, 2025."
  },
  "ja": {

  }
}
</i18n>
